/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { ReportingPeriodValue } from "../models/ui/reporting-period.model";
import { SelectOption } from "../models/ui/select-option.model";
import { TimePeriodRange } from "../models/ui/time-period-range.model";

const REPORTING_PERIOD_START_YEAR = 2025;
const FISCAL_YEAR_START_MONTH_INDEX = 3;
const FISCAL_YEAR_START_DAY = 1;

const buildReportingPeriodLabel = (startYear: number) => `FY ${startYear}`;

export function getReportingPeriodOptions(
	startYear: number = REPORTING_PERIOD_START_YEAR,
	endYear: number = new Date().getFullYear()
): SelectOption[] {
	if (endYear < startYear) {
		return [];
	}

	const options: SelectOption[] = [];

	for (let year = startYear; year <= endYear; year += 1) {
		options.push({
			label: buildReportingPeriodLabel(year),
			value: `FY_${year}` as ReportingPeriodValue
		});
	}

	return options;
}

export function getReportingPeriodRange(period: ReportingPeriodValue): TimePeriodRange {
	const startYear = Number.parseInt(period.replace("FY_", ""), 10);

	return {
		start: new Date(Date.UTC(startYear, FISCAL_YEAR_START_MONTH_INDEX, FISCAL_YEAR_START_DAY)),
		end: new Date(Date.UTC(startYear + 1, FISCAL_YEAR_START_MONTH_INDEX, FISCAL_YEAR_START_DAY))
	};
}

export function getDefaultReportingPeriodValue(date: Date = new Date()): ReportingPeriodValue {
	const startYear =
		date.getUTCMonth() >= FISCAL_YEAR_START_MONTH_INDEX
			? date.getUTCFullYear()
			: date.getUTCFullYear() - 1;

	return `FY_${startYear}`;
}

export function getFiscalYearRange(date: Date = new Date()): TimePeriodRange {
	return getReportingPeriodRange(getDefaultReportingPeriodValue(date));
}

export function getCurrentWeekRange(date: Date = new Date()): TimePeriodRange {
	const currentDay = date.getDay();
	const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;

	const monday = new Date(date);
	monday.setDate(date.getDate() + mondayOffset);

	const sunday = new Date(monday);
	sunday.setDate(monday.getDate() + 6);

	return {
		start: new Date(
			Date.UTC(monday.getFullYear(), monday.getMonth(), monday.getDate(), 0, 0, 0)
		),
		end: new Date(Date.UTC(sunday.getFullYear(), sunday.getMonth(), sunday.getDate() + 1))
	};
}
